module.exports = __webpack_public_path__ + "static/img/1-1.46ce6ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/1-1.png
// module id = 6Vu7
// module chunks = 0